import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=064ced32&scoped=true&"
import script from "./DocumentsSection.vue?vue&type=script&lang=js&"
export * from "./DocumentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ced32",
  null
  
)

export default component.exports